import type { StaleCrawlInfo } from '../api/types';

export type { StaleCrawlInfo };

/** Renders API `staleCrawl.label` — age is computed on the backend. */
export function StaleCrawlBadge({
  staleCrawl,
}: {
  staleCrawl: StaleCrawlInfo | null | undefined;
}) {
  if (!staleCrawl?.label) return null;

  return (
    <span
      className="badge badge-subtle-warning rounded-pill fs--2 text-nowrap flex-shrink-0"
      title={staleCrawl.label}
    >
      {staleCrawl.label}
    </span>
  );
}
